module.exports = "/packs/images/svg/ireland/facilities/pool~b47dd0faebf5acd611ed819520bd540b.svg";